module.exports = __webpack_public_path__ + "static/media/IMG_3733.d13e2fc0.jpg";